'use strict';

//Require Modules
var Backbone = require('backbone'),
  mediator = require('../../js/mediator'),
  config = require('../../js/config'),
  utilities = require('../../js/utilities'),
  formatCurrency = require('../../utilities/globalisation').formatCurrency,
  ProductPricingService = require('../../services/ProductPricingService').default;

let MerchandiseListPricingView = Backbone.View.extend({

  initialize: function() {
    // Store some require data
    var productData = this.$el.data('merchandising-line-item');
    this.partId = productData.partId || '';
    this.partNumber = productData.partNumber || '';
    this.manufacturer = productData.manufacturerSeo || '';

    mediator.on(config.events.pricing.received, this.onPricingReceived, this);
  },

  onPricingReceived: function(parts) {
    // Check we are the same part
    let part = ProductPricingService.findBuyingOption(parts, this.partId, this.partNumber, this.manufacturer);

    if (part) {
      // Remove the event handler as it is no longer needed
      mediator.off(config.events.pricing.received, this.onPricingReceived, this);
      this.updateViewWithPricingData(part.buyingOptions[0]);
    }
  },

  setPricingForBuyingOption: function(buyingOption) {
    var priceRange = 0;
    var showPricing = false;

    if (buyingOption.type === 'AddToCart' || buyingOption.type === 'Backorder') {
      priceRange = buyingOption.lowestDisplayPrice;
      showPricing = !!priceRange;

      if (priceRange && buyingOption.lowestDisplayPrice !== buyingOption.highestDisplayPrice) {
        priceRange = buyingOption.lowestDisplayPrice + ' - ' + buyingOption.highestDisplayPrice;
      }
    }

    // Update pricing
    if (showPricing) {
      var priceQuantityDiv = this.$el.children('.ProductMerchandiseList-item-purchase-info')[0];
      var quantityElement = priceQuantityDiv.getElementsByClassName('ProductMerchandiseList-item-purchase-info--quantity')[0];
      var quantity = quantityElement.innerText.replace('QUANTITY: ', '');
      var priceElement = priceQuantityDiv.getElementsByClassName('ProductMerchandiseList-item-purchase-info--price')[0];

      if (priceElement)
      {
        var totalPriceDiv = (this.$el.parent().parent().find('.ProductMerchandiseList-total')[0]);

        if (totalPriceDiv) {
          var totalPriceElement = totalPriceDiv.getElementsByClassName('ProductMerchandiseList-total-price')[0];
          var totalPrice = parseFloat(totalPriceElement.getAttribute('data-total-price'));
        }

        var merchandisingLineItem = this.$el.data('merchandising-line-item');
        if (buyingOption.priceBands.length === 1)
        {
          priceElement.innerText = priceRange || '';
          merchandisingLineItem.price = buyingOption.priceBands[0].price;
        }
        else {
          var priceBands = buyingOption.priceBands.filter(e => e.fromQuantity <= quantity && (e.toQuantity >= quantity || e.toQuantity === 0));

          if (priceBands.length >= 0)
          {
            priceElement.innerText = priceBands[0].displayPrice;
            merchandisingLineItem.price = priceBands[0].price;
          }
        }

        if (totalPriceDiv) {
          totalPrice += merchandisingLineItem.price * quantity;
          totalPriceElement.setAttribute('data-total-price', totalPrice);
          totalPrice = utilities.currencyRound(totalPrice);
          totalPriceElement.innerText = formatCurrency(totalPrice);
          this.$el.data('merchandising-line-item', merchandisingLineItem);
        }
      }
    }
  },

  /**
   * Format price and convert currency
   *
   * @param {float|number} price
   * @returns {float}
   */
  currencyFormatting: function(price) {
    if (price) {
      let forExPrice = utilities.applyExchangeRate(price);
      return formatCurrency(forExPrice);
    }
  },

  updateViewWithPricingData: function(buyingOption) {
    this.setPricingForBuyingOption(buyingOption);
  }
});

module.exports = MerchandiseListPricingView;



// WEBPACK FOOTER //
// ./assets/components/ProductMerchandiseList/MerchandiseListPricingView.js